"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLink = getLink;
exports.videoHasBeenCreated = videoHasBeenCreated;

var _VideoConferenceAPI = require("./VideoConferenceAPI");

function getLink(payload) {
  return (0, _VideoConferenceAPI.getVideoConferenceLink)(payload);
}

function videoHasBeenCreated() {
  return (0, _VideoConferenceAPI.storeVideoHasBeenCreated)();
}